import { render, staticRenderFns } from "./SurveyEditor.vue?vue&type=template&id=464c3cfb&scoped=true&"
import script from "./SurveyEditor.vue?vue&type=script&lang=js&"
export * from "./SurveyEditor.vue?vue&type=script&lang=js&"
import style0 from "./SurveyEditor.vue?vue&type=style&index=0&id=464c3cfb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464c3cfb",
  null
  
)

export default component.exports